/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PutResponsiveFileRequest
 */
export interface PutResponsiveFileRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PutResponsiveFileRequest
     */
    isWithheld: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PutResponsiveFileRequest
     */
    isArchived?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PutResponsiveFileRequest
     */
    isVerified?: boolean;
}

export function PutResponsiveFileRequestFromJSON(json: any): PutResponsiveFileRequest {
    return PutResponsiveFileRequestFromJSONTyped(json, false);
}

export function PutResponsiveFileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutResponsiveFileRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isWithheld': json['isWithheld'],
        'isArchived': !exists(json, 'isArchived') ? undefined : json['isArchived'],
        'isVerified': !exists(json, 'isVerified') ? undefined : json['isVerified'],
    };
}

export function PutResponsiveFileRequestToJSON(value?: PutResponsiveFileRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isWithheld': value.isWithheld,
        'isArchived': value.isArchived,
        'isVerified': value.isVerified,
    };
}


